"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SixDataChainConnector = void 0;
var Accounts_1 = require("./Accounts");
var nftmngrModuleGenerate = __importStar(require("../modules/sixnft/thesixnetwork.sixnft.nftmngr/module/index"));
var nftoracleModuleGenerate = __importStar(require("../modules/sixnft/thesixnetwork.sixnft.nftoracle/module/index"));
var nftadminModuleGenerate = __importStar(require("../modules/sixnft/thesixnetwork.sixnft.nftadmin/module/index"));
var SixDataChainConnector = /** @class */ (function () {
    /**
   * @param _nodeUrl is the url of the node to connect default is http://localhost
   * @param _portApi default is 1317
   * @param _portRpc default is 26657
   **/
    function SixDataChainConnector(_nodeUrl, _portApi, _portRpc) {
        if (_nodeUrl === void 0) { _nodeUrl = "http://localhost"; }
        if (_portApi === void 0) { _portApi = 1317; }
        if (_portRpc === void 0) { _portRpc = 26657; }
        var _this = this;
        this.accounts = new Accounts_1.Accounts();
        this.connectAPIClient = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, nftmngrModule, nftoracleModule, nftAdminModule;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            nftmngrModuleGenerate.queryClient({ addr: this.apiUrl }),
                            nftoracleModuleGenerate.queryClient({ addr: this.apiUrl }),
                            nftadminModuleGenerate.queryClient({ addr: this.apiUrl })
                        ])];
                    case 1:
                        _a = _b.sent(), nftmngrModule = _a[0], nftoracleModule = _a[1], nftAdminModule = _a[2];
                        return [2 /*return*/, {
                                nftmngrModule: nftmngrModule,
                                nftoracleModule: nftoracleModule,
                                nftAdminModule: nftAdminModule
                            }];
                }
            });
        }); };
        /**
        * @param accountSigner OfflineSigner
        * @example
        * const signer = await sixConnector.accounts.privateKeyToAccount("priveteKey")
        * const txClient = await sixConnector.connectRPCClient(signer)
        * @description connect to RPC client use for send transaction
        **/
        this.connectRPCClient = function (accountSigner, options) { return __awaiter(_this, void 0, void 0, function () {
            var _a, nftmngrModule, nftadminModule, nftoracleModule;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            nftmngrModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                            nftoracleModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                            nftadminModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options)
                        ])];
                    case 1:
                        _a = _b.sent(), nftmngrModule = _a[0], nftadminModule = _a[1], nftoracleModule = _a[2];
                        return [2 /*return*/, {
                                nftmngrModule: nftmngrModule,
                                nftadminModule: nftadminModule,
                                nftoracleModule: nftoracleModule,
                            }];
                }
            });
        }); };
        this.removeSLash = function (url) {
            if (url[url.length - 1] === "/")
                return url.slice(0, -1);
            return url;
        };
        var url = this.removeSLash(_nodeUrl);
        this.apiUrl = url + ":" + _portApi;
        this.rpcUrl = url + ":" + _portRpc;
    }
    return SixDataChainConnector;
}());
exports.SixDataChainConnector = SixDataChainConnector;
// InitQueryClient = async (
//     module: "nftmngrModule" | "evmsupportModule" | "adminModule" | "nftoracleModule",
//     addr: string
// ) => {
//     switch (module) {
//         case "nftmngrModule":
//             return await this.modules.nftmngrModule.queryClient({ addr: addr })
//         case "evmsupportModule":
//             return await this.modules.evmsupportModule.queryClient({ addr: addr })
//         case "adminModule":
//             return await this.modules.adminModule.queryClient({ addr: addr })
//         case "nftoracleModule":
//             return <Api>(await this.modules.nftoracleModule.queryClient({ addr: addr }))
//     }
// }
